

// Para obtener la documentación completa sobre las funciones API, incluidos ejemplos para programa con código, visita http://wix.to/94BuAAs

$w.onReady(function () {
	// TODO: write your page related code here...

});